import moment from 'moment'

/** essa funcao retorna a quantidade de dias corridos a partir da data inicial (init) até o a data final (end) */
export function daysBetween(init, end){
    let initial = moment(init);
    let final = moment(end);
    let duration = moment.duration(final.diff(initial))
    return parseInt(duration.asDays()) + 1
}